/* Reveal the table fill only when the last outline phase has painted. */
document.addEventListener('animationend', function (event) {
  var target = event.target;
  if (!(target instanceof Element)) return;
  if (event.animationName === 'akTableVertical' && target.matches('.ak-table-side i')) {
    target.closest('.ak-table-board').classList.add('ak-cta-outline-ready');
  }
  if (event.animationName === 'akKpDrawX' && target.matches('.ak-kp-top-left')) {
    target.closest('.ak-kp-board').classList.add('ak-cta-outline-ready');
  }
}, true);


/* Fit the Gallery word to 57% of its video opening after the font is ready. */
(function () {
  function initGalleryWidth() {
    document.querySelectorAll('.ak-galleryportal-hatch-v8__artwork-lockup').forEach(function (box) {
      var title = box.querySelector('.ak-galleryportal-hatch-v8__artwork-image');
      if (!title || box.dataset.akTitleFitBound) return;
      box.dataset.akTitleFitBound = 'true';
      function fit() {
        if (!matchMedia('(min-width: 1201px)').matches) return;
        var width = box.getBoundingClientRect().width;
        var textWidth = title.getBoundingClientRect().width;
        if (!width || !textWidth) return;
        var size = parseFloat(getComputedStyle(title).fontSize) * width * .57 / textWidth;
        title.style.setProperty('--ak-gallery-desktop-title-fit', size.toFixed(4) + 'px');
      }
      var observer = new ResizeObserver(fit);
      observer.observe(box);
      document.fonts.ready.then(fit);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGalleryWidth, {once: true});
  else initGalleryWidth();
  document.addEventListener('shopify:section:load', initGalleryWidth);
})();

/* One close graphic, shared proportions and one native entrance spin.
   Observe only close controls and their ancestor states; nothing runs at idle. */
(() => {
  if (window.akUnifiedCloseReady) return;
  window.akUnifiedCloseReady = true;
  const selectors = [
    '.ak-directory-menu__close','.ak-mobile-directory__close',
    '.ak-simple-gallery__close','.ak-galleryportal-hatch-v8__close',
    '.ak-entergallery-mobile__close','.ak-mobile-cart-close',
    '.ak-cart-panel-close-box','.ak-predictive-toolbar-close-box',
    '.ak-mobile-search-intro-toolbar-close-box','.ak-search-top-close-box',
    '.ak-single-level-menu-mobile-close',
    'button:has(svg.ak-close-icon)','a:has(> svg.ak-close-icon)',
    '[role="button"]:has(svg.ak-close-icon)'
  ].join(',');
  const controls = new Map();
  let watched = new WeakSet();
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  let frame = 0;
  const nextFrame = () => new Promise(resolve => requestAnimationFrame(resolve));
  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }
  function visible(state) {
    const host = state.host;
    if (document.hidden || !host.isConnected || !state.intersecting ||
        host.closest('.is-closing,.is-close-leaving,.ak-search-overlay-leave')) return false;
    for (let node=host; node && node instanceof Element; node=node.parentElement) {
      const style=getComputedStyle(node);
      if (node.hidden || style.display==='none' || style.visibility==='hidden' ||
          style.visibility==='collapse' || Number(style.opacity)<.01) return false;
    }
    return true;
  }
  async function enter(state) {
    state.shown = true;
    const run = ++state.run;
    if (reduced.matches) return;
    await nextFrame();
    await nextFrame();
    if (run!==state.run || !visible(state)) return;
    const entrances=[];
    for (let node=state.host; node && node!==document.body; node=node.parentElement) {
      node.getAnimations().forEach(animation => {
        if (animation.effect?.getComputedTiming().iterations !== Infinity) entrances.push(animation.finished.catch(()=>{}));
      });
    }
    await Promise.all(entrances);
    if (run!==state.run || !visible(state) || reduced.matches) return;
    const animation=state.glyph.animate([{rotate:'0deg'},{rotate:'720deg'}],{
      duration:600,easing:'cubic-bezier(.3,.2,.15,1)'
    });
    state.animation=animation;
    animation.finished.then(()=>{
      if (state.animation===animation) state.animation=null;
      animation.cancel();
    }).catch(()=>{});
  }
  function leave(state) {
    state.shown=false;
    ++state.run;
    state.animation?.cancel();
    state.animation=null;
  }
  function update() {
    frame=0;
    let pruned=false;
    controls.forEach(state=>{
      if (!state.host.isConnected) {
        leave(state); sizes.unobserve(state.host); intersections?.unobserve(state.host);
        controls.delete(state.host); pruned=true; return;
      }
      if (state.glyph.parentElement!==state.host) {
        leave(state); controls.delete(state.host); register(state.host); return;
      }
      const shown=visible(state);
      if (shown && !state.shown) enter(state);
      else if (!shown && state.shown) leave(state);
    });
    if (pruned) {
      statuses.disconnect();
      watched=new WeakSet();
      controls.forEach(state=>watch(state.host));
    }
  }
  const statuses=new MutationObserver(schedule);
  const intersections=typeof IntersectionObserver==='function' ? new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      const state=controls.get(entry.target);
      if (state) state.intersecting=entry.isIntersecting;
    });
    schedule();
  }) : null;
  const sizes=new ResizeObserver(entries=>{
    entries.forEach(entry=>{
      const host=entry.target;
      const style=getComputedStyle(host);
      const box=entry.borderBoxSize?.[0];
      const bounds=box ? {width:box.inlineSize,height:box.blockSize} : host.getBoundingClientRect();
      const width=bounds.width-(parseFloat(style.borderLeftWidth)||0)-(parseFloat(style.borderRightWidth)||0);
      const height=bounds.height-(parseFloat(style.borderTopWidth)||0)-(parseFloat(style.borderBottomWidth)||0);
      if (width<=0 || height<=0) return;
      const value=(Math.min(width,height)*.54).toFixed(3)+'px';
      if (host.style.getPropertyValue('--ak-close-glyph-size')!==value) host.style.setProperty('--ak-close-glyph-size',value);
    });
    schedule();
  });
  function register(host) {
    if (controls.has(host)) return;
    host.setAttribute('data-ak-close-unified','');
    if (getComputedStyle(host).position==='static') host.setAttribute('data-ak-close-positioned','');
    const existing=Array.from(host.children).filter(child=>child.classList.contains('ak-unified-close-glyph'));
    const glyph=existing.shift() || document.createElement('i');
    existing.forEach(duplicate=>duplicate.remove());
    glyph.className='ak-unified-close-glyph';
    glyph.setAttribute('aria-hidden','true');
    if (glyph.parentElement!==host) host.appendChild(glyph);
    const state={host,glyph,shown:false,run:0,animation:null,intersecting:!intersections};
    controls.set(host,state);
    sizes.observe(host); intersections?.observe(host);
    watch(host);
  }
  function watch(host) {
    for (let node=host; node && node instanceof Element; node=node.parentElement) {
      if (watched.has(node)) continue;
      watched.add(node);
      const ownState=node===host || node===host.parentElement || node===host.parentElement?.parentElement ||
        node.matches('.ak-search-overlay,.ak-cart-overlay,.ak-directory-menu,.ak-mobile-directory,.ak-simple-gallery,dialog,[role="dialog"]');
      statuses.observe(node,{attributes:true,attributeFilter:ownState ? ['class','style','hidden','open'] : ['class','hidden','open']});
    }
  }
  function discover(root) {
    if (!(root instanceof Element || root instanceof Document)) return;
    if (root instanceof Element && root.matches(selectors)) register(root);
    root.querySelectorAll(selectors).forEach(register);
    if (root instanceof Element) {
      const button=root.closest('button,a,[role="button"]');
      if (button?.matches(selectors)) register(button);
    }
  }
  discover(document);
  new MutationObserver(records=>{
    records.forEach(record=>record.addedNodes.forEach(discover));
    if (records.some(record=>record.removedNodes.length)) schedule();
  }).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('transitionend',event=>{if(watched.has(event.target)) schedule();},true);
  document.addEventListener('animationend',event=>{if(watched.has(event.target)) schedule();},true);
  document.addEventListener('visibilitychange',()=>{
    if (document.hidden) controls.forEach(leave);
    else schedule();
  });
  reduced.addEventListener('change',()=>{controls.forEach(leave);schedule();});
  schedule();
})();
